var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHealthcare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.1875,
    y: 0.861328,
    width: 71.0144,
    height: 71.0144,
    rx: 35.5072,
    fill: "#4745B7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32.6901 27.7113V45.8682H30.3195V37.6363H21.0717V45.8682H18.7012V27.7113H21.0717V35.6826H30.3195V27.7113H32.6901ZM35.5916 36.6985C35.5916 34.8924 35.9823 33.286 36.7638 31.8793C37.5453 30.4552 38.6308 29.3524 40.0201 28.5709C41.4268 27.772 43.0159 27.3726 44.7873 27.3726C46.9581 27.3726 48.8163 27.9457 50.362 29.0919C51.9076 30.2381 52.9409 31.8011 53.4619 33.7809H48.5645C48.1998 33.0168 47.6788 32.435 47.0015 32.0356C46.3416 31.6361 45.5861 31.4364 44.7352 31.4364C43.3632 31.4364 42.2517 31.914 41.4008 32.8692C40.5498 33.8243 40.1243 35.1008 40.1243 36.6985C40.1243 38.2963 40.5498 39.5727 41.4008 40.5279C42.2517 41.4831 43.3632 41.9607 44.7352 41.9607C45.5861 41.9607 46.3416 41.7609 47.0015 41.3615C47.6788 40.9621 48.1998 40.3803 48.5645 39.6161H53.4619C52.9409 41.596 51.9076 43.159 50.362 44.3052C48.8163 45.434 46.9581 45.9984 44.7873 45.9984C43.0159 45.9984 41.4268 45.6077 40.0201 44.8262C38.6308 44.0273 37.5453 42.9245 36.7638 41.5178C35.9823 40.1111 35.5916 38.5047 35.5916 36.6985Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHealthcare);
export default __webpack_public_path__ + "static/media/healthcare.ba5cbd10e2bd5bcedffdcbafb79f2a90.svg";
export { ForwardRef as ReactComponent };